export enum FimpMeasuredValueFormat {
  NUMERIC = 'NUMERIC',
  SEE_JS101 = 'SEE_JS101',
  SEE_JS103 = 'SEE_JS103',
  SEE_REPORT = 'SEE_REPORT',
  SEE_TXT = 'SEE_TXT',
  SEE_GL128 = 'SEE_GL128',
  SEE_GL127 = 'SEE_GL127',
  SEE_JLCL101 = 'SEE_JLCL101',
  SEE_JLCL103 = 'SEE_JLCL103',
}

export const FimpMeasuredValueFormatMap = {
  [FimpMeasuredValueFormat.NUMERIC]: '填写数值',
  [FimpMeasuredValueFormat.SEE_JS101]: '来自JS101',
  [FimpMeasuredValueFormat.SEE_JS103]: '来自JS103',
  [FimpMeasuredValueFormat.SEE_REPORT]: '见报告',
  [FimpMeasuredValueFormat.SEE_TXT]: '其他文本',
  [FimpMeasuredValueFormat.SEE_GL128]: '来自GL128',
  [FimpMeasuredValueFormat.SEE_GL127]: '来自GL127',
  [FimpMeasuredValueFormat.SEE_JLCL101]: '来自JLCL101',
  [FimpMeasuredValueFormat.SEE_JLCL103]: '来自JLCL103',
};

export const FimpMeasuredValueFormatOptions = [
  {
    label: FimpMeasuredValueFormatMap[FimpMeasuredValueFormat.NUMERIC],
    value: FimpMeasuredValueFormat.NUMERIC,
  },
  {
    label: FimpMeasuredValueFormatMap[FimpMeasuredValueFormat.SEE_JS101],
    value: FimpMeasuredValueFormat.SEE_JS101,
  },
  {
    label: FimpMeasuredValueFormatMap[FimpMeasuredValueFormat.SEE_JS103],
    value: FimpMeasuredValueFormat.SEE_JS103,
  },
  {
    label: FimpMeasuredValueFormatMap[FimpMeasuredValueFormat.SEE_GL128],
    value: FimpMeasuredValueFormat.SEE_GL128,
  },
  {
    label: FimpMeasuredValueFormatMap[FimpMeasuredValueFormat.SEE_GL127],
    value: FimpMeasuredValueFormat.SEE_GL127,
  },
  {
    label: FimpMeasuredValueFormatMap[FimpMeasuredValueFormat.SEE_JLCL101],
    value: FimpMeasuredValueFormat.SEE_JLCL101,
  },
  {
    label: FimpMeasuredValueFormatMap[FimpMeasuredValueFormat.SEE_JLCL103],
    value: FimpMeasuredValueFormat.SEE_JLCL103,
  },
  {
    label: FimpMeasuredValueFormatMap[FimpMeasuredValueFormat.SEE_REPORT],
    value: FimpMeasuredValueFormat.SEE_REPORT,
  },
  {
    label: FimpMeasuredValueFormatMap[FimpMeasuredValueFormat.SEE_TXT],
    value: FimpMeasuredValueFormat.SEE_TXT,
  },
];
